import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e49dbda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__price" }
const _hoisted_2 = {
  key: 0,
  class: "product__price--discount"
}
const _hoisted_3 = {
  key: 1,
  class: "product__price--final"
}

import { toRefs, reactive } from 'vue';
import { ICartItem } from '@/store/cart/_types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartProductPrice',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ICartItem;
};



const { item } = reactive(props);
const { product } = toRefs(item);

return (_ctx: any,_cache: any) => {
  const _component_AppNumber = _resolveComponent("AppNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["product__price--full", { crossed: _unref(product)['discountPercentage'] }])
    }, [
      _createVNode(_component_AppNumber, {
        input: _unref(item).countPrice,
        fixed: 2
      }, null, 8 /* PROPS */, ["input"]),
      _createTextVNode(" $ ")
    ], 2 /* CLASS */),
    (_unref(product).discountPercentage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Sale: " + _toDisplayString(_unref(product).discountPercentage) + "% ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_unref(product).discountPercentage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_AppNumber, {
            input: _unref(item).fixPrice,
            fixed: 2
          }, null, 8 /* PROPS */, ["input"]),
          _createTextVNode(" $ ")
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})